export default "__VITE_ASSET__D3sw3h9T__"